import './InventoryStatus.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import useTranslation from '@hooks/useTranslation';
import { createClsNameMap } from '@utils';
import { useMemo } from 'react';

const clsNameMap = createClsNameMap({})('inventory-status');

export type InventoryStatusProps = {
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: string | number;
  fontSize?: string | number;
  inStockColor?: string;
  lowStockColor?: string;
  soldOutColor?: string;
  lowInventoryThreshold?: number;
  inventory: number | null;
  isSoldOut?: boolean;
};

enum InventoryType {
  SoldOut = 'inventorySoldOut',
  InStock = 'inventoryInStock',
  LowStock = 'inventoryLowStock',
}

const InventoryStatus = (props: InventoryStatusProps) => {
  const { t } = useTranslation();

  const {
    textTransform,
    fontFamily,
    fontStyle,
    fontWeight,
    fontSize,
    inStockColor,
    lowStockColor,
    soldOutColor,
    lowInventoryThreshold,
    inventory,
    isSoldOut,
  } = props;

  const translation = useMemo(() => {
    if (isSoldOut) return InventoryType.SoldOut;
    if (lowInventoryThreshold === undefined || inventory === null) return '';
    if (inventory > lowInventoryThreshold) return InventoryType.InStock;
    else return InventoryType.LowStock;
  }, [isSoldOut, lowInventoryThreshold, inventory]);

  const color = useMemo(() => {
    const mappingColor = {
      [InventoryType.SoldOut]: soldOutColor,
      [InventoryType.InStock]: inStockColor,
      [InventoryType.LowStock]: lowStockColor,
    };
    return translation ? mappingColor[translation] : '';
  }, [translation, soldOutColor, inStockColor, lowStockColor]);

  if (!translation) return <></>;

  return (
    <span
      className={clsNameMap.root()}
      style={{
        fontFamily,
        fontStyle,
        fontWeight,
        fontSize,
        color,
        textTransform,
      }}
    >
      {textTransform === 'none'
        ? t(`productItem.${translation}`, {
            count: inventory ?? 0,
          })
        : t(`productItem.${translation}`, {
            count: inventory ?? 0,
          }).toLowerCase()}
    </span>
  );
};

export default registryComponent('InventoryStatus', InventoryStatus);
